export default "__VITE_ASSET__BXxSdBeC__"